import { render, staticRenderFns } from "./EducationalCategoryDelete.vue?vue&type=template&id=23609c26&"
import script from "./EducationalCategoryDelete.vue?vue&type=script&lang=js&"
export * from "./EducationalCategoryDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports